'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Author: Alexandre Havrileck (Oxyno-zeta)
 * Date: 23/10/16
 * Licence: See Readme
 */

/* ************************************* */
/* ********       IMPORTS       ******** */
/* ************************************* */

/* ************************************* */
/* ********      VARIABLES      ******** */
/* ************************************* */
var ADD_DELTA_TYPE = 'ADD_DELTA_TYPE';
var REMOVE_DELTA_TYPE = 'REMOVE_DELTA_TYPE';
var UPDATE_DELTA_TYPE = 'UPDATE_DELTA_TYPE';

/* ************************************* */
/* ********  PRIVATE FUNCTIONS  ******** */
/* ************************************* */

/* ************************************* */
/* ********   PUBLIC FUNCTIONS  ******** */
/* ************************************* */

/* ************************************* */
/* ********       EXPORTS       ******** */
/* ************************************* */
exports.ADD_DELTA_TYPE = ADD_DELTA_TYPE;
exports.REMOVE_DELTA_TYPE = REMOVE_DELTA_TYPE;
exports.UPDATE_DELTA_TYPE = UPDATE_DELTA_TYPE;